export default (state = {}, action) => {

    switch (action.type) {

    case 'UPDATE_ACTIVE_REPORT_SECTION':
    return action.payload;

    default:

    return state;

    }

    };